import './types';

/**
 * Разворачивает Mini App на весь экран и отключает закрытие вертикальным свайпом.
 * Без этого прокрутка/смахивание внутри приложения роняет его — Telegram трактует
 * вертикальный жест как «свернуть/закрыть». Вызывать один раз при старте, как только
 * присутствует Telegram-SDK (не зависит от initData/входа). Методы опциональны:
 * на старых клиентах Telegram их может не быть — тогда тихий no-op.
 */
export function setupTelegramViewport(): void {
  const webApp = typeof window !== 'undefined' ? window.Telegram?.WebApp : undefined;
  if (!webApp) return;
  try {
    webApp.expand?.();
    webApp.disableVerticalSwipes?.();
  } catch {
    // Старый клиент / метод отсутствует — не критично для работы приложения.
  }
}
